import { request_list } from '@/commons/hpod';
import Vue from 'vue';
const viewTitle = 'dashboard'
// initial state
const state = {
    loading: false,
    tu_delay: {},
    dnhu_delay: {},
    hu_delay: {},
    monthly_report: {},
    three_month_report: {},
    sale_monthly_report: {}
};

// getters
const getters = {};

// actions
const actions = {
    get_tu_delay({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('dashboard/tu-delay', data => {
            commit('set_tu_delay', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    get_dnhu_delay({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('dashboard/dnhu-delay', data => {
            commit('set_dnhu_delay', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    get_hu_delay({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('dashboard/hu-delay', data => {
            commit('set_hu_delay', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    get_monthly_report({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('dashboard/monthly-report', data => {
            commit('set_monthly_report', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    get_3month_report({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('dashboard/three-month-report', data => {
            commit('set_3month_report', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    get_sale_monthly_report({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('dashboard/sale-monthly-report', data => {
            commit('set_sale_monthly_report', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    }
};

// mutations
const mutations = {
    set_tu_delay(state, data) {
        state.tu_delay = data;
    },
    set_dnhu_delay(state, data) {
        state.dnhu_delay = data;
    },
    set_hu_delay(state, data) {
        state.hu_delay = data;
    },
    set_monthly_report(state, data) {
        state.monthly_report = data;
    },
    set_3month_report(state, data) {
        state.three_month_report = data;
    },
    set_sale_monthly_report(state, data) {
        state.sale_monthly_report = data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
